import combinedGACall from '../combinedGACall';

export default (action, label) =>
	combinedGACall({
		category: 'Vaccination statuses',
		action,
		...(label ? { label } : null),
	});
